"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledDecisionTreeButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledDecisionTreeButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "DecisionTreeButtonstyles__StyledDecisionTreeButton",
  componentId: "e782pn-0"
})(["display:flex;flex-flow:row nowrap;justify-content:space-between;"]);
exports.StyledDecisionTreeButton = StyledDecisionTreeButton;

var StyledLabel = _styledComponents.default.div.withConfig({
  displayName: "DecisionTreeButtonstyles__StyledLabel",
  componentId: "e782pn-1"
})(["text-align:left;"]);

exports.StyledLabel = StyledLabel;